<template>
    <div class="qcart-table">
        <!-- 表格 -->
        <el-table
			empty-text="暫無數據"
            :data="quote_cart"
            ref="quoteTable"
            tooltip-effect="dark"
            :row-key="getRowKeys"
            @selection-change="handleSelect">
            <!-- 多选框 -->
            <el-table-column
                type="selection"
                :reserve-selection="true"
                align="center"
                width="55">
            </el-table-column>
            <!-- 商品名称 -->
            <el-table-column
                :label="$t('message.cqcart.table1')"
                align="center"
                width="250"
                show-overflow-tooltip>
                <template v-slot="{ row }">
                    <div class="quote_cart_goods">
                        <!-- 图片 -->
                        <router-link
                            :to="{
                                name: 'pdetail',
                                query: {
                                    id: row.goods_id
                                },
                                params: {
                                    cate_id: row.cat_id
                                }
                            }"
                            class="quote_cart_goods_img">
                            <img :src="row.goods_images[0]" alt="">
                        </router-link>
                        <!-- 图片 -->
                        <router-link
                            :to="{
                                name: 'pdetail',
                                query: {
                                    id: row.goods_id
                                },
                                params: {
                                    cate_id: row.cat_id
                                }
                            }">
                            <span>{{row.goods_name}}</span>
                        </router-link>
                    </div>
                </template>
            </el-table-column>
            <!-- 计数器 -->
            <el-table-column
                :label="$t('message.cqcart.table2')"
                align="center">
                <template v-slot="{ row }">
                    <el-input-number
                        :value="row.goods_number"
                        size="mini"
                        :min="1"
                        @change="handleNum($event,row)">
                    </el-input-number>
                </template>
            </el-table-column>
            <!-- 单位 -->
            <!-- <el-table-column
                :label="$t('message.cqcart.table3')"
                prop="unit"
                align="center"
                show-overflow-tooltip>
            </el-table-column> -->
            <!-- 类型 -->
            <el-table-column
                label="規格"
                align="center">
                <template v-slot="{ row }">
                    <el-select
						placeholder="請選擇"
                        :value="row.goods_specification_id"
                        size="mini"
                        @change="handleAttr(row.goods_attr_id,$event,row)"
                        :disabled="!row.goods_specification_id">
                        <el-option
                            v-for="(item,index) in row.attr2"
                            :key="index"
                            :label="item.attr_value"
                            :value="item.goods_attr_id">
                        </el-option>
                    </el-select>
                </template>
            </el-table-column>
            <!-- 类型 -->
            <el-table-column
                label="顏色"
                align="center">
                <template v-slot="{ row }">
                    <el-select
						placeholder="請選擇"
                        :value="row.goods_attr_id"
                        size="mini"
                        @change="handleAttr($event,row.goods_specification_id,row)"
                        :disabled="!row.goods_attr_id">
                        <el-option
                            v-for="(item,index) in row.attr"
                            :key="index"
                            :label="item.attr_value"
                            :value="item.goods_attr_id">
                        </el-option>
                    </el-select>
                </template>
            </el-table-column>
            <!-- 删除 -->
            <el-table-column
                :label="$t('message.cqcart.table5')"
                align="center">
                <template v-slot="{ row }">
                    <el-button
                        size="mini"
                        type="danger"
                        @click="handleDel($event,row.quo_id)">
                        <span>{{$t("public.delBtn")}}</span>
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 合计行 -->
        <div class="qcart-table-total">
            <!-- 取消报价按钮 -->
            <el-button
                type="text"
                class="qcart-table-btn"
                @click="handleDel">
                <span>{{$t("message.cqcart.delAllBtn")}}</span>
            </el-button>
            <!-- 备注填写框 -->
            <el-input
                v-model="postscript"
                type="textarea"
                :rows="1"
                :placeholder="$t('message.cqcart.remarks')"
                class="qcart-table-remarks">
            </el-input>
            <!-- 右侧统计&添加 -->
            <div class="qcart-table-handle">
                <!-- 数量统计 -->
                <div class="qcart-table-handle-num">
                    <span>{{$t("message.cqcart.total1")}}</span>
                    <span class="quote_cart_table_total_num">{{totalNum}}</span>
                    <span>{{$t("message.cqcart.total2")}}</span>
                </div>
                <!-- 提交按钮 -->
                <el-button
                    type="primary"
                    @click="handleSubmit"
                    class="qcart-table-btn">
                    <span>{{$t("public.submitBtn")}}</span>
                </el-button>
                <!-- 加入购物车 -->
                <el-button
                    type="primary"
                    @click="handleAddCart"
                    class="qcart-table-btn">
                    <span>{{$t("message.cqcart.addCart")}}</span>
                </el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    data() {
        return {
            quote_select: [], // 多选参数
            postscript: ''
        }
    },
    computed: mapState({
        power: state => state.user.power,
        quote_cart: state => state.order.quote_cart,
        totalNum(){
            let total = 0;
            for(let item of this.quote_select){
                this.quote_cart.find((source, index, arr) => {
                    if(source.quo_id == item){
                        total += Number(source.goods_number)
                    }
                })
            }
            return total;
        }
    }),
    methods: {
        ...mapActions([
            "handleQuoteCartNum",
            "handleQuoteCartDel",
            "handleSubmitQuoteCart",
            "handleQuoteCartToCart"
        ]),
        getRowKeys(row){ // 行key
            return row.quo_id
        },
        handleSelect(val){ // 选项发生改变时
            let new_val = [];
            for(let item of val){
                new_val.push(item.quo_id)
            }
            this.quote_select = new_val;
        },
        handleNum(goods_number,item){ // 计数器处理函数
            let { quo_id, goods_attr_id, goods_specification_id } = item;
            this.handleQuoteCartNum({
                quo_id,
                goods_attr_id,
                goods_number,
                goods_specification_id
            })
        },
        handleAttr(goods_attr_id, goods_specification_id, item){ // 下拉框处理函数
            let { quo_id, goods_number } = item;
            this.handleQuoteCartNum({
                quo_id,
                goods_attr_id,
                goods_number,
                goods_specification_id
            })
        },
        handleDel($event,id){ // 删除报价车
            let quo_id = [];
            if(id){
                quo_id.push(id)
            }else{
                quo_id = this.quote_select;
            }
            if(quo_id.length == 0){ // 判定是否有删除商品id
                this.$message({
                    showClose: true,
                    message: this.$t("message.cqcart.errmsg1"),
                    type: "warning"
                })
                return
            }
            this.quote_cart.find((val, index, arr) => {
                if(quo_id.includes(val.quo_id)){
                    this.$refs.quoteTable.toggleRowSelection(val,false);
                }
            })
            this.handleQuoteCartDel(quo_id).then((res) => {
                if(res){
                    this.$message({
                        showClose: true,
                        message: $t("public.delSucc"),
                        type: "success"
                    })
                }
            })
        },

		
        handleSubmit(){ // 提交报价车
            let allow = this.power.includes(0) || this.power.includes(111) || this.power.includes(6);
            if(!allow){
                this.$message({
                    showClose: true,
                    message: this.$t("message.cqcart.errmsg3"),
                    type: "error"
                })
                return
            }
            let new_arr = [];	
			
			
			 
			
            this.quote_cart.find((val, index, arr) => {
                if(this.quote_select.includes(val.quo_id)){
					// let obj = {
					// 	quo_id:val.quo_id
					// } 
					// new_arr.push(val)
                    // new_arr.push(obj)
					new_arr.push(val.quo_id)
                }
            })
			
			
            if(new_arr.length == 0){
                this.$message({
                    showClose: true,
                    message: this.$t("message.cqcart.errmsg1"),
                    type: "warning"
                })
                return
            }
            this.handleSubmitQuoteCart({
                goods: new_arr,
                postscript: this.postscript
            }).then((res) => {
				// console.log(res,'查看')
                if(res){
                    this.$refs.quoteTable.clearSelection();
                    this.$message({
                        showClose: true,
                        message: this.$t("message.cqcart.succmsg1"),
                        type: "success"
                    })
                }else{
					this.$message({
					    showClose: true,
					    message: this.$t("message.cqcart.succmsg3"),
					    type: "warning"
					})
				}
            })
        },
        handleAddCart(){ // 添加到购物车
            let new_arr = [];
            this.quote_cart.find((val, index, arr) => {
                if(this.quote_select.includes(val.quo_id)){
                    new_arr.push(val)
                }
            })
            if(new_arr.length == 0){
                this.$message({
                    showClose: true,
                    message: this.$t("message.cqcart.errmsg1"),
                    type: "warning"
                })
                return
            }
            this.handleQuoteCartToCart(new_arr).then((res) => {
                if(res){
                    this.$message({
                        showClose: true,
                        message: this.$t("message.cqcart.succmsg2"),
                        type: "success"
                    })
                }else{
                    this.$message({
                        showClose: true,
                        message: this.$t("message.cqcart.errmsg2"),
                        type: "warning"
                    })
                }
            })
        }
    },
    mounted() {
        this.$refs.quoteTable.toggleAllSelection();
    },
}
</script>

<style scoped>
.qcart-table{
    background: #fff;
}
/* 商品参数盒子 */
.quote_cart_goods{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: left;
}
/* 商品图片 */
.quote_cart_goods_img{
    position: relative;
    display: inline-block;
    vertical-align: middle;
    width: 50px;
    height: 50px;
    margin-right: 5px;
}
.quote_cart_goods_img>img{
    max-width: 100%;
    max-height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
}

/* 统计区域 */
.qcart-table-total{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    background-color: #EBEEF5;
}
.qcart-table-remarks {
    width: 300px;
}
/* 数量统计 */
.qcart-table-handle-num{
    display: inline-block;
    margin-right: 15px;
    line-height: 50px;
}
.quote_cart_table_total_num{
    margin: 0 5px;
    color: #ff6700;
}
/* 按钮 */
.qcart-table-btn{
    width: 115px;
    height: 50px;
}
</style>
